/* stylelint-disable property-no-vendor-prefix */
import styled, { css } from "styled-components"

const transtionsStyles = css`
  transition: all 0.2s;
  touch-action: manipulation;
`

const StyledUpdateButtonsWrapper = styled.div`
  margin-bottom: 1.6rem;
  > label {
    margin-bottom: 0.4rem;
    display: block;
  }
`

const actionStyles = css`
  &::-webkit-input-placeholder {
    opacity: 0;
    transition: inherit;
  }

  &:focus {
    outline: 0;
  }

  &:placeholder-shown + label {
    cursor: text;
    max-width: 66.66%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    transform-origin: left bottom;
    transform: translate(1.2rem, 3rem) scale(1.166);
  }

  &:not(:placeholder-shown) + label,
  &:focus + label {
    transform: translate(0, -0.4rem) scale(1);
    cursor: pointer;
  }

  &:focus::-webkit-input-placeholder {
    opacity: 1;
  }
`
const textStyles = css`
  font-family: ${({ theme }) => theme.font.family.body};
  font-size: ${({ theme }) => theme.font.size.s};
  line-height: 1.71;
  color: ${({ theme }) => theme.color.secondary01};
`
const inputStyles = css`
  border: 0;
  border: 1px solid ${({ theme }) => theme.color.secondary04};
  -webkit-appearance: none;
  border-radius: 0;
  cursor: text;
  padding: 0.8rem 1.2rem;
  background-color: transparent;
  margin-bottom: 2.4rem;

  ${({ iserror }) =>
    iserror &&
    css`
      border-color: ${({ theme }) => theme.color.tertiary03};
    `}

  ${textStyles}
  ${actionStyles}
  ${transtionsStyles}
`

const StyledForm = styled.form`
  width: 100%;
  max-width: 34.3rem;
  display: flex;
  flex-direction: column;
  margin-top: 1rem;
`

const StyledField = styled.div`
  display: flex;
  flex-flow: column-reverse;
  position: relative;
`

const StyledLabel = styled.label`
  font-size: ${({ theme }) => theme.font.size.xs};
  font-family: ${({ theme }) => theme.font.family.body};
  color: ${({ theme }) => theme.color.secondary02};
  width: max-content;

  ${transtionsStyles}
`

const StyledInput = styled.input`
  ${inputStyles}
`

const StyledPhoneInput = styled.input`
  ${inputStyles}
  margin-left: 11.9rem;
  margin-bottom: 2.4rem;
  padding-left: 0.8rem;

  &:placeholder-shown + label {
    transform: translate(0, -0.4rem);
  }

  &::-webkit-input-placeholder {
    opacity: 1;
  }
`

const StyledError = styled.span`
  font-family: ${({ theme }) => theme.font.family.body};
  font-size: ${({ theme }) => theme.font.size.xs};
  line-height: 1.67;
  letter-spacing: 0.25px;
  color: ${({ theme }) => theme.color.tertiary03};
  position: absolute;
  left: 0;
  bottom: 0.4rem;
  height: 2rem;
`
const StyledPhoneInputCountry = styled.div`
  align-self: stretch;
  display: flex;
  align-items: center;
  position: absolute;
  top: 1.5rem;
  width: 10.5rem;
  height: 4.1rem;
`

const StyledCountrySelect = styled.select`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 1;
  border: 0;
  opacity: 0;
  cursor: pointer;
`
const flagDropdownStyles = css`
  padding: 0.8rem 1.2rem;
  border: 1px solid ${({ theme }) => theme.color.secondary04};
  top: 1em;

  &:after {
    right: 0.8rem;
  }
`

export {
  StyledForm,
  StyledField,
  StyledInput,
  StyledLabel,
  StyledError,
  StyledPhoneInput,
  StyledPhoneInputCountry,
  StyledCountrySelect,
  flagDropdownStyles,
  StyledUpdateButtonsWrapper,
}
